import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useSidebarCollapse } from "@/hooks/useSidebarCollapse";

export function CollapseButton() {
  const { isCollapsed, toggle } = useSidebarCollapse();

  return (
    <Button
      variant="ghost"
      className="absolute top-6 h-7 w-7 rounded-full border border-border bg-card hover:bg-accent text-muted-foreground hover:text-foreground transition-all duration-300 z-30 p-0"
      style={{ left: isCollapsed ? "calc(4.5rem - 1rem)" : "calc(240px - 1rem)" }}
      onClick={toggle}
      aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
    >
      <ChevronLeft
        className={cn(
          "h-4 w-4 transition-transform",
          isCollapsed && "rotate-180"
        )}
      />
    </Button>
  );
}
